var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightQuotesBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FDEDEA;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.3,53.2c2.7,0,5.3-0.5,7.7-1.5c-1.9,6.5-4.9,13.2-9,19.7c-1.6,2.4-3.2,4.7-4.9,6.9 c6.7-3.6,13.3-9.8,18.5-17.9c5.8-9.2,8.6-18.9,8.4-27.1c0-0.3,0-0.5,0-0.8c0-3.9-1.1-7.5-2.9-10.6c0,0,0,0,0,0 c-3.6-6.1-10.2-10.1-17.8-10.1c-11.4,0-20.7,9.3-20.7,20.7C48.6,43.9,57.8,53.2,69.3,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.7,53.2c2.7,0,5.3-0.5,7.7-1.5c-1.9,6.5-4.9,13.2-9,19.7c-1.6,2.4-3.2,4.7-4.9,6.9 c6.7-3.6,13.3-9.8,18.5-17.9c5.8-9.2,8.6-18.9,8.4-27.1c0-0.3,0-0.5,0-0.8c0-3.9-1.1-7.5-2.9-10.6c0,0,0,0,0,0 c-3.6-6.1-10.2-10.1-17.8-10.1C9.3,11.7,0,21,0,32.5S9.3,53.2,20.7,53.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightQuotesBlack);
export default __webpack_public_path__ + "static/media/right-quotes-black.af3bfe15ae079497d8ba57407029f93d.svg";
export { ForwardRef as ReactComponent };